import React from 'react';
import { Link } from 'react-router-dom';

import Button from '../../common/button/button';

import './header-section.css';

export default function HeaderSection() {
  const tags = [
    {
      filePath: '/images/article-tags/typescript2.png', 
      visibleName: 'TypeScript',
      className: 'notsvg',
    },    
    {
      filePath: '/images/article-tags/angular.svg', 
      visibleName: 'Angular',
    },
    {
      filePath: '/images/article-tags/javascript.svg', 
      visibleName: 'JavaScript',
    },     
    {
      filePath: '/images/article-tags/react.svg', 
      visibleName: 'React',
    },
    {
      filePath: '/images/article-tags/more/node.png', 
      visibleName: 'NodeJS',
      className: 'notsvg',
    },       
    // {
    //   filePath: 'life.png', 
    //   visibleName: 'Personal Growth',
    // },    
  ];//'golang'

  const phrases = ["JavaScript", "Angular", "React", "Web"];
  const phrases2 = ["js", "dev", "web"];
  
  const interval = 4000;
  const typistProps = {
    blink: true,
    avgTypingDelay: 40,
    hideWhenDone: true,
    startDelay: 500,
  };

  return (
    <section className='section-container new-home-header-section'>
      <h3 className='page-title'>
        <span className='title-part'>JavaScript</span> 
        <span className='title-part'>on</span>

        <span className='title-part'>
          Steroids
        </span>
      </h3>

      <div className='header-buttons-container'>
        <Link to='/articles' title='Read Our Articles'>
          <Button 
            label='Read Our Articles' 
            isOutlined={ true } />
        </Link>

        <Link to='/newsletters/ag/angular/subscription' title='Subscribe to Our Newsletter'>
          <Button 
            label='Subscribe to Our Newsletter' 
            isDark={ true } />
        </Link>         
      </div>      

      {/*<h3 className='page-title'>
        DM.
        <TextCarousel 
          phrases={phrases2} 
          interval={interval} 
          typistProps={typistProps} />               
        
      </h3>*/}

      <h4 className='page-sub-title'>
        <span className='title-part'>Become a Ninja</span> 
        <span className='title-part'>Web Developer</span> 
        {/*<TextCarousel 
          phrases={phrases2} 
          interval={interval} 
          typistProps={typistProps} />               */}
        
      </h4>

      <div className='tags-container'>
        {
          tags.map(({ visibleName, filePath, className }, i) =>
            <img
              key={ `tag-${ i }` } 
              alt={ visibleName } 
              title={ visibleName }
              className={ className || '' } 
              src={ filePath } />
          )
        }
      </div>
    </section>
  );
};

  {/*<Link to='/team' title='Our Team'>
    <Button 
      label='Explore More' 
      isDark={ this.props.className !== 'dark' } />
  </Link>*/}